import Animation from '@eversports/klimt-animations/Animation'
import Box from '@eversports/klimt-primitives/legacy/Box'

import usePrefersReducedMotion from '../../../../hooks/use-prefers-reduced-motion'

import GiftBoxMotion from './assets/gift-box-motion.lottie'

export function VoucherGiftAnimation() {
  const prefersReducedMotion = usePrefersReducedMotion()

  return (
    <Box sx={{ width: 156, height: 134 }}>
      <Animation
        src={GiftBoxMotion}
        style={{ width: '100%', height: '100%' }}
        loop={!prefersReducedMotion}
        autoplay={!prefersReducedMotion}
      />
    </Box>
  )
}
